import * as React from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Typography, Button } from '@mui/material';
import Input from '@mui/joy/Input';
import { useNavigate } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { useEffect } from 'react';
import axios from 'axios';
import HeadBar from './HeadBar';
import ErrorMessageDialog from './ErrorMessageDialog';

export default function Register() {
  let rcListItems = <></>;
  let blockListItems = <></>;

  const [rcList, setRCList] = React.useState([]);
  const [blockList, setBlockList] = React.useState([]);
  const [rc, setRC] = React.useState('');
  const [rcDescription, setRCDescription] = React.useState('');
  const [block, setBlock] = React.useState('');
  const [blockDescription, setBlockDescription] = React.useState('');
  const [floor, setFloor] = React.useState('');
  const [room, setRoom] = React.useState('');
  const [height, setHeight] = React.useState('');
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [errMessage, setErrMessage] = React.useState("");
  const [contactInfo, setContactInfo] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  const SITE_KEY = process.env.REACT_APP_SITE_KEY;
  const main_url = process.env.REACT_APP_MAIN_URL;

  const fetchRCs = async () => {
    await axios.get(main_url + "load_parameters?parameters=RcList")
      .then(response => {
        setRCList(response.data);
        setRC(response.data[0].rc_code);
        setRCDescription(response.data[0].description);
        fetchBlocks(response.data[0].rc_code);
      })
      .catch(error => {
        console.error(error);
      });
  };
  const fetchBlocks = async (currentRC) => {
    await axios.get(main_url + "load_parameters?parameters=BlockList&rc_code=" + currentRC)
      .then(response => {
        setBlockList(response.data);
        setBlock(response.data[0].block_code);
        setBlockDescription(response.data[0].description);
      })
      .catch(error => {
        console.error(error);
      });
  };
  const registerAccount = async (request) => {
    const response = await axios.post(main_url + "register", request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.log("Error in calling register function - POST");
        console.error(error);
      });
    return response;
  };

  const handleChangeRC = (event) => {
    setRC(event.target.value);
    const rCDescription = rcList.find((rC)=>(rC.rc_code==event.target.value));
    setRCDescription(rCDescription.description);
    
    fetchBlocks(event.target.value);
  };

  const handleChangeBlock = (event) => {
    setBlock(event.target.value);
    const blockDescription = blockList.find((block)=>(block.block_code==event.target.value));
    setBlockDescription(blockDescription.description);
  };

  const handleChangeFloor = (event) => {
    if (!isNegative(event.target.value)) {
      setFloor(event.target.value);
    }
  };

  const formatFloor = (floor) => {
    var floorValue = Number(floor);
    return (floorValue < 10 ? ('0' + floorValue) : floorValue);
  }

  const handleChangeRoom = (event) => {
    const limitLength = 4;
    if (event.target.value.toString().length <= limitLength) {
      setRoom(event.target.value);
    }
  };

  const handleChangeHeight = (event) => {
    if (!isNegative(event.target.value)) {
      setHeight(event.target.value);
    }
  };

  const isNegative = (value) => {
    if (value < 0) return true;
    return false;
  }

  const handleDialogOpen = (errMessage) => {
    setDialogOpen(!dialogOpen);
    setIsError(true);
    setErrMessage(errMessage);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setContactInfo(false);
    handleLoading();
  };

  const handleLoading = () => {
    setLoading(!loading);
  }

  const validate = (rc, block, floor, room, height) => {
    const heightMax = 200;
    const heightMin = 120;
    if (rc == '' || block == '' || floor == '' || room == '' || height == '') {
      handleDialogOpen("INFO_REQUIRED");
      return false;
    } else if ((height < heightMin) || (height > heightMax)) {
      handleDialogOpen("HEIGHT_RANGE");
      return false;
    }
    return true;
  }

  const handleOnClick = e => {

    e.preventDefault();
    handleLoading(); // start loading

    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(SITE_KEY, { action: 'submit' })
        .then(token => {
          if (token != null && token != '') {
            if (validate(rc, block, floor, room, height)) {
              var requestData = {
                "rc": rc,
                "block": block,
                "floor": formatFloor(floor),
                "room": room,
                "height": height,
                "token": token,
                "source": "WEB",
              };

              registerAccount(requestData)
                .then((responseData) => {

                  if (responseData.status != 'ERROR') {

                    handleLoading(); // stop loading
                    navigate("/successreg", {
                      state: {
                        "rc": rcDescription,
                        "block": blockDescription,
                        "floor": formatFloor(floor),
                        "room": room,
                        "height": height,
                        "password": responseData.password,
                      }
                    });
                  } else {
                    handleDialogOpen(responseData.err_msg);
                  }

                });
            }
          }
        });
    });
  }

  useEffect(() => {

    // fetch Data for Dropdown select
    fetchRCs();

    // for GoogleReCaptcha
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    }

    // load the script by passing the URL
    loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`, function () {
      console.log("Script loaded!");
    });

  }, []);

  rcListItems = rcList.map((rc) => {
    return <MenuItem value={rc.rc_code}>{rc.description}</MenuItem>
  });
  blockListItems = blockList.map((block) => {
    return <MenuItem value={block.block_code}>{block.description}</MenuItem>
  });


  return (
    <div>
      <HeadBar />

      {/* Status Information */}
      <Box backgroundColor={'#F4B183'} paddingY={1} sx={{ textAlign: 'center' }}>
        <Typography>Enter your Room Information</Typography>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

        {/* RC/Hall*/}
        <Box sx={{ marginTop: "2%" }}>
          <Typography marginTop={2} style={{ fontSize: 18, fontWeight: 'bold' }}>
            Residential College/Hall
          </Typography>
          <FormControl fullWidth>
            <Select
              style={{
                height: 45, borderRadius: "6px",
                width: 300,
                borderColor: "1px solid rgb(69,68,66,0.5)",
                backgroundColor: "white"
              }}
              value={rc}
              onChange={handleChangeRC}
              required
            >
              {rcListItems}
            </Select>
          </FormControl>
        </Box>

        {/* Block */}
        <Box marginTop={2} >
          <Typography style={{ fontSize: 18, fontWeight: 'bold' }}>
            Block
          </Typography>
          <FormControl fullWidth>
            <Select
              style={{
                height: 45, borderRadius: "6px",
                width: 300,
                borderColor: "1px solid rgb(69,68,66,0.5)",
                backgroundColor: "white"
              }}
              id="demo-simple-select"
              value={block}
              onChange={handleChangeBlock}
              required
            >
              {blockListItems}
            </Select>
          </FormControl>
        </Box>

        {/* Room Number */}
        <Box marginTop={2} >
          <Typography style={{ fontSize: 18, fontWeight: 'bold' }}>
            Floor & Room Number
          </Typography>
          <Box style={{ width: 300 }} display="flex" flexDirection="row">
            <Box width={100} marginRight={"20px"}>
              <FormControl fullWidth>
                <Input
                  style={{
                    borderRadius: "6px",
                    borderColor: "1px solid rgb(69,68,66,0.5)"
                  }}
                  variant="outlined"
                  placeholder='Floor'
                  type="number"
                  // id="demo-simple-select"
                  value={floor}
                  onChange={handleChangeFloor}
                  required
                >
                  {floor}
                </Input>
              </FormControl>
            </Box>

            <Box width={100}>
              <FormControl fullWidth>
                <Input
                  style={{
                    borderRadius: "6px",
                    borderColor: "1px solid rgb(69,68,66,0.5)"
                  }}
                  variant="outlined"
                  placeholder='Unit'
                  inputProps={{ maxLength: 2 }}
                  //type="number"
                  // id="demo-simple-select"
                  value={room}
                  onChange={handleChangeRoom}
                  required
                >
                  {room}
                </Input>
              </FormControl>
            </Box>

          </Box>
        </Box>

        {/* Height */}
        <Box marginTop={2}>
          <Typography style={{ fontSize: 18, fontWeight: 'bold' }}>
            What is your height?
          </Typography>
          <Typography style={{ fontSize: 12, width : 300 }}>
            You will be prompted at the Resource Sorting Station if you
            forget your password
          </Typography>
          <Box height={10} />
          <Box style={{ width: 300 }} display="flex" flexDirection="row">
            <FormControl fullWidth>
              <Input
                style={{
                  width: 100,
                  borderRadius: "6px",
                  borderColor: "1px solid rgb(69,68,66,0.5)",
                  backgroundColor: "white",
                }}
                inputProps={{ min: 0 }}
                variant="outlined"
                placeholder='0'
                type="number"
                value={height}
                onChange={handleChangeHeight}
                required
              >
                {height}
              </Input>
            </FormControl>
            <Typography style={{ fontSize: 18, marginTop: 5 }}>cm</Typography>
            <Box marginLeft={20} />
          </Box>

        </Box>
        {/* ReCAPTCHA version2 */}
        {/* <ReCAPTCHA sitekey={process.env.REACT_APP_SITE_KEY} ref={captchaRef} onSubmit={handleButtonDisable}/> */}

        {/* Button */}
        <Box marginY={3}>
          <FormControl fullWidth>
            <Button
              style={{
                width: 300,
                height: 45,
                color: "black",
                backgroundColor: loading ? "#93BB87" : "#A7DB8C",
                borderColor: "#FF8C00",
                fontSize: 16,
              }}
              disabled={loading}
              onClick={handleOnClick}
            >
              {loading ? 'LOADING ...' : 'GENERATE PASSWORD'}
            </Button>
          </FormControl>
        </Box>

      </Box>

      {/* Error Message Dialog */}
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        {isError ?
          <Dialog
            borderRadius={7}
            open={dialogOpen}
            onClose={handleDialogClose}
            PaperProps={{ sx: { width: 280 } }}
          >

            <DialogTitle sx={{ paddingTop: 1, height: 20, textAlign: "center", color: "white" }} backgroundColor="red">
              <Typography sx={{ fontSize: 20, fontWeight: "bold" }}>{"Error"}</Typography>
            </DialogTitle>

            <ErrorMessageDialog errMsg={errMessage} />

            <DialogActions sx={{ justifyContent: "center", paddingBottom: 4 }}>
              <Button style={{ backgroundColor: "#A7DB8C", color: "black", width: 100, height: 35 }} onClick={handleDialogClose} autoFocus>
                OK
              </Button>
            </DialogActions>

          </Dialog> : <></>}
      </Box>
    </div>
  );
}